import type { ReactNode } from "react";
import { lazy } from "react";

const key = import.meta.env.VITE_POSTHOG_KEY;
const host = import.meta.env.VITE_POSTHOG_HOST;

const NullComponent = ({ children }: { children: ReactNode }) => {
  return children;
};

const PostHogPreloadProvider =
  key && host
    ? lazy(() => import("./post-hog-provider").then((module) => ({ default: module.PostHogProvider })))
    : NullComponent;

export { PostHogPreloadProvider };
